import { PersonaDetails } from '../../../types/persona/persona-data'
import { axios, Response } from '../index'

const getPatientDetails = (patientId: string): Response<PersonaDetails> => {
  return axios.get(`/v1/patients/${patientId}`)
}

export default getPatientDetails
